module.exports = __webpack_public_path__ + "font/open-sans-bold.92425c6.woff2";